import React, { useContext } from "react";
import PageData from "../PageData";
import WidgetsProvider from "../common/WidgetsProvider";
import MainContext from "../contexts/MainContext";
import { useFetchSeoSettings } from "../data/fetchSeoSettings";
import { SeoContext } from "../data/seo/SeoContextProvider";
import SeoMainContainer from "../data/seo/SeoMainContainer";
import SeoMetaTags from "../data/seo/SeoMetaTags";
import { useHandleSeoSettings } from "../data/seo/seoUtils";
import { getConfiguration } from "../data/utils";
import LastMinuteContent from "./LastMinute";
import LiveMatches from "./LiveMatches";
import TopLeagues from "./TopLeagues";
import TopMatches from "./TopMatches";

import "./landing-4.css";
import SwiperItems from "./SwiperItems";
import LandingSwiperCarousel from "./LandingSwiperCarousel";
import LastMinuteGrouped from "./LastMinuteGrouped";
import { systemCode } from "..";


function getOrderedComponents(systemCode) {
  const isSurebet = systemCode === 'SUREBET';

  const sections = isSurebet
    ? ["B", "SC", "SI", "TL", "HL", "TM", "LE", "TS", "S", "LM"]
    : ["B", "SC", "SI", "TL", "HL", "LE", "LM", "TM", "TS", "S"];

  const components = [];

  sections.forEach((section) => {
    components.push({ type: 'section', key: section });

    // dove vogliamo inserire i caroselli
    if (systemCode === 'SUREBET') {
      if (section === 'LE') {
        components.push({ type: 'carousel', key: 'carousel-1', group: 2 });
      }
      if (section === 'LM') {
        components.push({ type: 'carousel', key: 'carousel-2', group: 3 });
      }
    }
  });

  return components;
}

export default function Landing4(props) {
  const conf = getConfiguration();
  const mainContext = useContext(MainContext);
  const cfgSeo = conf.seo;
  const seoContext = useContext(SeoContext);

  const [seoSettingsState] = useFetchSeoSettings(
    seoContext.pathname,
    false,
    cfgSeo &&
    mainContext.currentSection.current === "top-match" &&
    !props.openFromPath
  );

  useHandleSeoSettings(seoSettingsState);

  const elements = getOrderedComponents(systemCode);

  return (
    <>
      <SeoMetaTags />
      <div className="griglia-centrale-sport col stringimento-sidebar ord-2" id="div-centrale">
        <div className="contenitore-schedine-sport">
          <div id="xs-landing-4">
            <WidgetsProvider>
              {elements.map((el) => {
                if (el.type === 'carousel') {
                  return (
                    <React.Fragment key={el.key}>
                      <LandingSwiperCarousel onlyGroup={el.group} />
                    </React.Fragment>
                  );
                }

                if (el.type === 'section') {
                  switch (el.key) {
                    case "TL":
                      return <TopLeagues key={el.key} />;
                    case "LE":
                      return <LiveMatches key={el.key} />;
                    case "LM":
                      return systemCode === 'SUREBET'
                        ? <LastMinuteGrouped key={el.key} />
                        : <LastMinuteContent key={el.key} />;
                    case "TM":
                      return <TopMatches key={el.key} />;
                    case "S":
                      return <SeoMainContainer key={el.key} />;
                    case "SC":
                      return (
                        <PageData key={el.key}>
                          <LandingSwiperCarousel onlyGroup={0} />
                        </PageData>
                      );
                    case "SI":
                      return <SwiperItems key={el.key} />;
                    default:
                      return null;
                  }
                }

                return null;
              })}

            </WidgetsProvider>
          </div>
        </div>
      </div>
    </>
  );
}

